import React from 'react';
import LegalDocument from './LegalDocument';

// Thin wrapper. The document body lives in content/legal/ai-policy.md and reaches
// this file through legal-content.generated.js — see LegalDocument.jsx.
export default function AIPolicy() {
    return <LegalDocument slug="ai-policy" />;
}
